import { ColumnId, Option, OptionRow, OptionType } from '../types'

export function mergeOptionsBy(options: Option[], mergeBy: ColumnId.StrikePrice | ColumnId.ExpirationDate) {
  const result: OptionRow[] = []
  const sorted = options.slice().sort((a, b) => a[mergeBy] - b[mergeBy])

  for (const option of sorted) {
    let last = result[result.length - 1]
    if (last?.[mergeBy] !== option[mergeBy]) {
      last = { strike: option.strike, exDate: option.exDate, call: null, put: null }
      result.push(last)
    }

    if (option.type === OptionType.Call) {
      last.call = option
    } else {
      last.put = option
    }
  }

  return result
}
